import React, { useState, useEffect } from 'react';
import { incomeAPI } from '../../api';

const AdminIncomes = () => {
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchIncomes();
  }, []);

  const fetchIncomes = async () => {
    try {
      setLoading(true);
      const response = await incomeAPI.getAllIncome();
      setIncomes(response.data || []);
    } catch (error) {
      console.error('Error fetching incomes:', error);
      setIncomes([]);
    } finally {
      setLoading(false);
    }
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'PAID':
        return 'bg-green-100 text-green-700';
      case 'PENDING':
        return 'bg-yellow-100 text-yellow-700';
      case 'REJECTED':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#E4572E] border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="bg-[#F8FAFC] p-6 rounded-2xl">

      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-3xl font-bold text-[#0F2F3D]">Income Records</h2>
          <p className="text-gray-500 mt-1">
            Track all commissions and platform earnings
          </p>
        </div>

        <button
          onClick={fetchIncomes}
          className="px-4 py-2 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] text-white rounded-lg shadow hover:opacity-90 transition-all duration-300"
        >
          Refresh
        </button>
      </div>

      {/* Table Card */}
      <div className="bg-white rounded-2xl shadow-md overflow-hidden">

        <div className="overflow-x-auto">
          <table className="w-full">

            {/* Table Head */}
            <thead className="bg-[#0F2F3D] text-white">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold">SR. No</th>
                <th className="px-6 py-4 text-left text-sm font-semibold">User</th>
                <th className="px-6 py-4 text-left text-sm font-semibold">Email</th>
                <th className="px-6 py-4 text-left text-sm font-semibold">Type</th>
                <th className="px-6 py-4 text-left text-sm font-semibold">Amount</th>
                {/* <th className="px-6 py-4 text-left text-sm font-semibold">Status</th> */}
                {/* <th className="px-6 py-4 txt-left text-sm font-semibold">Net Amount</th> */}
                <th className="px-6 py-4 text-left text-sm font-semibold">Date</th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className="divide-y divide-gray-200">
              {incomes.length > 0 ? (
                incomes.map((income, index) => (
                  <tr
                    key={index}
                    className="hover:bg-[#E4572E]/5 transition-all"
                  >
                    <td className="px-6 py-4 font-medium text-[#0F2F3D]">{index + 1}</td>
                    <td className="px-6 py-4 font-medium text-[#0F2F3D]">
                      {income.userId?.name || 'N/A'}
                    </td>

                    <td className="px-6 py-4 text-sm text-gray-600">
                      {income.userId?.email || 'N/A'}
                    </td>

                    <td className="px-6 py-4 text-sm capitalize">
                      {income.type?.replace(/_/g, ' ') || '-'}
                    </td>

                    <td className="px-6 py-4 font-bold text-[#E4572E]">
                      ₹{income.amount?.toLocaleString() || 0}
                    </td>

                    {/* <td className="px-6 py-4">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusStyle(
                          income.status
                        )}`}
                      >
                        {income.status}
                      </span>
                    </td> */}

                    {/* <td className="px-6 py-4 text-sm font-medium text-[#0F2F3D]">
                      ₹{income.netAmount?.toLocaleString() || 0}
                    </td> */}

                    <td className="px-6 py-4 text-sm text-gray-500">
                      {new Date(income.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center py-10 text-gray-500"
                  >
                    No income records found.
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      </div>
    </div>
  );
};

export default AdminIncomes;